import React, { ReactNode } from "react";
import { Button } from "capitalrx-components";
import ToggleButton from "@/App/components/ToggleButton";
import classNames from "classnames";

export interface ButtonContent {
  handleClick?: (ev: React.MouseEvent) => void;
  path?: string;
  title: string | ReactNode;
  color?: string;
  buttonType?: "link" | "router-link" | null;
  buttonStyle?: string;
}

interface Props {
  children: ReactNode;
  title: ReactNode;
  buttonContent?: ButtonContent;
  extraContent?: ReactNode;
  showButton?: boolean;
  showExtraContent?: boolean;
  showToggleButton?: boolean;
  rightToggleURL?: string;
  leftToggleURL?: string;
  rightToggleContent?: string;
  leftToggleContent?: string;
  leftToggleSelected?: boolean;
  rightToggleSelected?: boolean;
  buttonClassName?: string;
  pageContentHeaderClassName?: string;
  pageContentWrapperClassName?: string;
  theme?: string;
}

const PageContent: React.FC<Props> = (props: Props) => {
  const {
    title,
    buttonContent = {} as ButtonContent,
    extraContent,
    children,
    showButton = false,
    showExtraContent = false,
    showToggleButton = false,
    rightToggleURL,
    leftToggleURL,
    rightToggleContent,
    leftToggleContent,
    leftToggleSelected = false,
    rightToggleSelected = false,
    buttonClassName = "",
    pageContentHeaderClassName = "",
    pageContentWrapperClassName = "",
    theme,
  } = props;
  const {
    handleClick = (): void => null,
    path = "",
    title: buttonTitle = "",
    color = "darkblue",
    buttonType = "router-link",
    buttonStyle = "outline",
  } = buttonContent;

  const button = (
    <Button
      buttonType={buttonType}
      path={path}
      buttonStyle={buttonStyle}
      color={color}
      extraClasses={buttonClassName}
      handleClick={handleClick}
    >
      {buttonTitle}
    </Button>
  );

  const toggleButton = (
    <ToggleButton
      rightButtonAction={rightToggleURL}
      leftButtonAction={leftToggleURL}
      leftButtonContent={leftToggleContent}
      rightButtonContent={rightToggleContent}
      leftButtonSelected={leftToggleSelected}
      rightButtonSelected={rightToggleSelected}
    ></ToggleButton>
  );

  const pageContentWrapperClasses = classNames("page-content-wrapper", pageContentWrapperClassName, theme);

  const pageContentHeaderClasses = classNames("page-content-header", pageContentHeaderClassName);

  return (
    <div className={pageContentWrapperClasses}>
      <div className={pageContentHeaderClasses}>
        <div className="page-content-title">{title}</div>
        {showButton && buttonContent && button}
        {showExtraContent && extraContent}
        {showToggleButton && toggleButton}
      </div>
      {children}
    </div>
  );
};

export default PageContent;
